import _ from 'lodash'
import { computed, ref } from 'vue';
import scroll from 'scroll-into-view-if-needed';
import type { CatalogItem, CatalogsInViewItem } from '@/types';

export function getInRange(els: Element[], range = [0, window.innerHeight]) {
    const elTop = _.orderBy(_.map(els, function(item) {
        return {
            el: item,
            top: item.getBoundingClientRect().top,
        }
    }), ['top'], ['asc']);
    const elRange = _.map(elTop, (item, idx) => {
        const next = elTop[idx + 1];
        return {
            el: item.el,
            range: [item.top, next ? next.top - 1 : Infinity],
        }
    });
    return _.map(_.reject(elRange, (item) => {
        return item.range[0] > range[1] || item.range[1] < range[0]
    }), 'el');
}

export function useCatalog(props: {
    catalogList: CatalogItem[]
}) {
    const catalogsInView = ref<CatalogsInViewItem[]>([])
    const viewRange = ref<[number, number]>([0, Infinity]);

    const activatedCatalog = computed(() => {
        return catalogsInView.value?.[0]?.task_group_type;
    })

    function updateViewPort(range: [number, number]) {
        viewRange.value = range
    }

    function getInView() {
        const elSelectorList = _.map(props.catalogList, catalog => {
            return {
                ...catalog,
                el: document.querySelector(`.report-card-content .report-card-task__${catalog.task_group_type}`),
            }
        }).filter(data => data.el)
        const elsInView = getInRange(elSelectorList.map(({ el }) => el!), viewRange.value);
        catalogsInView.value = elSelectorList.filter(item => _.find(elsInView, el => el === item.el))
    }

    function watch(container: Nullable<Element>) {
        const throttleFunc = _.throttle(getInView, 200);
        container?.addEventListener('scroll', throttleFunc);
        throttleFunc();
        return () => {
            container?.removeEventListener('scroll', throttleFunc);
            catalogsInView.value = [];
        }
    }

    function scrollIntoView(catalog: CatalogItem, offset = 0) {
        const el = document.querySelector(`.report-card-content .report-card-task__${catalog.task_group_type}`)
        if (!el) return;
        scroll(el, {
            scrollMode: 'always',
            block: 'start',
            behavior: (actions) => {
                const all = _.sum(_.map(actions, 'top'));
                actions.forEach(({ el }) => {
                    el.scrollTop = all + offset;
                });
            },
        })
    }

    return {
        updateViewPort,
        catalogsInView,
        watch,
        scrollIntoView,
        activatedCatalog,
    }
}
